import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import FormBuilder from '../helpers/form-builder';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import initialState from '../helpers/form-helpers/initial-state';
import { formConstants } from '../../utils/constants/form-constants';
import SSOCloseButton from '../../common/utility/SSOCloseButton';
import './user-addresses.scss';
import { deepCopyObject } from '../../utils/obj-utils';

class AddAddressForm extends Component {
    constructor(props) {
        super(props);
        this.state = initialState.addUserAddressesFormState;

        this.displayAddAddressForm = this.displayAddAddressForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.submitAddressData = this.submitAddressData.bind(this);
        this.buildNewAddress = this.buildNewAddress.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {
            loading,
            formData,
            retrievedUserAddress,
            isUserAddressRetrieveSuccessful
        } = nextProps;

        if (!loading && isUserAddressRetrieveSuccessful) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
        }
    }

    displayAddAddressForm() {
        const { actions, formData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, state } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        return FormBuilder({
            formData: copyOfFormData,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),
                    () => {
                        actions.resetRetrievedUserAddress();
                    });
            },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitAddressData);
    }

    submitAddressData() {
        const { onAddAddressClick } = this.props;
        onAddAddressClick(this.buildNewAddress());
    }

    buildNewAddress() {
        const newAddress = {};
        newAddress[formConstants.addressLine1] = this.state[formConstants.addressLine1];
        newAddress[formConstants.addressLine2] = this.state[formConstants.addressLine2];
        newAddress[formConstants.addressLine3] = this.state[formConstants.addressLine3];
        newAddress[formConstants.postcode] = this.state[formConstants.postcode];
        newAddress[formConstants.city] = this.state[formConstants.city];
        newAddress[formConstants.country] = this.state[formConstants.country];
        newAddress[formConstants.county] = this.state[formConstants.county];
        newAddress[formConstants.state] = this.state[formConstants.state];
        newAddress[formConstants.main] = this.state[formConstants.mainAddress];
        newAddress[formConstants.shippingAddress] = this.state[formConstants.shippingAddress];
        newAddress[formConstants.billingAddress] = this.state[formConstants.billingAddress];
        return newAddress;
    }

    render() {
        const { onCloseAddAddressFormClick } = this.props;
        return (
            <div className='form-popup form-container'>
                <section className='form-popup__content'>
                    <SSOCloseButton onCloseButtonClick={onCloseAddAddressFormClick}></SSOCloseButton>
                    <form onSubmit={this.handleSubmit}>
                        {this.displayAddAddressForm()}
                        <SSOFormFooter
                            onSubmit={this.handleSubmit}
                            footerButtonText={formMessageConstants.saveAddress}>
                        </SSOFormFooter>
                    </form>
                </section>
            </div>
        );
    }
}

AddAddressForm.propTypes = {
    formData: PropTypes.object.isRequired,
    onAddAddressClick: PropTypes.func.isRequired,
    onCloseAddAddressFormClick: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAddressForm);
